/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The ForgotPasswordResponse model module.
 * @module model/ForgotPasswordResponse
 * @version v1
 */
export class ForgotPasswordResponse {
  /**
   * Constructs a new <code>ForgotPasswordResponse</code>.
   * @alias module:model/ForgotPasswordResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ForgotPasswordResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ForgotPasswordResponse} obj Optional instance to populate.
   * @return {module:model/ForgotPasswordResponse} The populated <code>ForgotPasswordResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ForgotPasswordResponse();
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} status
 */
ForgotPasswordResponse.prototype.status = undefined;

/**
 * @member {String} message
 */
ForgotPasswordResponse.prototype.message = undefined;

